import {Component, Inject, LOCALE_ID} from '@angular/core';
import {SelectOption} from '../dropdown/select-dropdown/select-dropdown';
import {MatSymbol} from '../models/mat-symbol';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  standalone: false
})
export class LanguageSwitchComponent {
  /** Labels name each language in itself, so they are the same in either locale. */
  readonly languageOptions: SelectOption<string>[] = [
    {value: 'en', label: 'EN'},
    {value: 'hu', label: 'HU'},
  ];
  readonly languageSymbol: MatSymbol = {symbol: 'public'};

  selectedLanguage = this.locale;

  constructor(@Inject(LOCALE_ID) private locale: string) { }

  /**
   * The bundle is per-locale, so switching is a reload of the sibling URL rather than anything
   * in-app: `/en/...` and `/hu/...` are different builds.
   */
  onLanguageChange(language: string) {
    let url = window.location.href;
    if (language === 'en') {
      url = url.replace(/\/hu\//g, '/en/');
    } else {
      url = url.replace(/\/en\//g, '/hu/');
    }
    window.location.replace(url);
  }
}
